var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'wgt-hotzone': true,
  'padded': _vm.value.padded
}},[_c('CompHotimg',{attrs:{"value":_vm.value,"visible":_vm.visible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }